module.exports = __webpack_public_path__ + "static/the-icarus-deception-1558c3aafd40bba24d08c5d22d1e7f8c.jpg";